import React from 'react';
import { Field } from 'redux-form';
import { renderDollar, renderNumberPercentage } from '../../Utils/renderField/renderField';
import { positiveNumberField } from '../../../../utility/getErrors';

const ComportamientoCreditoFiscal = props => {
    return (
        <div>
            <h5 className='fn-info-sb'>OTRAS VARIABLES</h5>
            <span className='fn-info-sb'>Variable por centrifugación</span>
            <div className='hr-info'>
                <hr />
            </div>
            <div className='fn-info'>
                <div className="parametros__fields-row">
                    <div className="parametros__field-wrapper">
                        <label htmlFor="credito5" className="m-0">RENDIMIENTO DE CENTRIFUGADO</label>
                        <Field name="var_yield" component={renderNumberPercentage} type="text" className="form-control" />
                    </div>
                    <div className="parametros__field-wrapper">
                        <label htmlFor="nombre" className="m-0">SKIM</label>
                        <Field name="var_skim" component={renderNumberPercentage} type="text" className="form-control" />
                    </div>
                    <div className="parametros__field-wrapper">
                        <label htmlFor="nombre" className="m-0">PÉRDIDA ESTIMADA EN CENTRIFUGACIÓN</label>
                        <Field name="var_lost" component={renderNumberPercentage} type="text" className="form-control" />
                    </div>
                </div>
            </div>
            <span className='fn-info-sb'>Variable por manejo</span>
            <div className='hr-info'>
                <hr />
            </div>
            <div className='fn-info'>
                <div className="parametros__fields-row">
                    <div className="parametros__field-wrapper">
                        <label htmlFor="var_clot_wash" className="m-0">COÁGULO DE LAVADO DE PILAS Y CENTRIFUGAS</label>
                        <Field name="var_clot_wash" component={renderNumberPercentage} type="text" className="form-control" />
                    </div>

                    <div className="parametros__field-wrapper">
                        <label htmlFor="nombre" className="m-0">COÁGULO DE TRAMPAS</label>
                        <Field name="var_clot_traps" component={renderNumberPercentage} type="text" className="form-control" />
                    </div>
                    <div className="parametros__field-wrapper">
                        <label htmlFor="nombre" className="m-0">COÁGULO DE LÁTEX CENTRIFUGADO</label>
                        <Field name="var_clot_centrifuged" component={renderNumberPercentage} type="text" className="form-control" />
                    </div>
                </div>
            </div>
            <div className='fn-info'>
                <div className="parametros__fields-row">
                    <div className="parametros__field-wrapper">
                        <label htmlFor="var_clot_wash" className="m-0">PORCENTAGE DE SKIM PARA MEZCLAR CON SÓLIDOS</label>
                        <Field name="skim_ratio_for_solids" component={renderNumberPercentage} type="text" className="form-control" />
                    </div>
                </div>
            </div>
            <span className='fn-info-sb'>Variables extras</span>
            <div className='hr-info'>
                <hr />
            </div>
            <div className='fn-info'>
                <div className="parametros__fields-row">
                    <div className="parametros__field-wrapper">
                        <label htmlFor="latex_makeup_price" className="m-0">PRECIO MAQUILA DE LÁTEX</label>
                        <Field
                            name="latex_makeup_price"
                            component={renderDollar}
                            type="text"
                            className="form-control"
                            validate={[positiveNumberField]}
                        />
                    </div>
                    <div className="parametros__field-wrapper">
                        <label htmlFor="solid_makeup_price" className="m-0">PRECIO MAQUILA DE SÓLIDOS/SKIM</label>
                        <Field
                            name="solid_makeup_price"
                            component={renderDollar}
                            type="text"
                            className="form-control"
                            validate={[positiveNumberField]}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ComportamientoCreditoFiscal;
